'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = useActive;

var _react = require('react');

var keyTogglesActive = function keyTogglesActive(_ref) {
  var key = _ref.key;
  return key === 'Enter' || key === ' ';
};

function useActive(_ref2) {
  var active = _ref2.active,
      onMouseDown = _ref2.onMouseDown,
      onKeyDown = _ref2.onKeyDown,
      onKeyUp = _ref2.onKeyUp,
      onBlur = _ref2.onBlur;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      activeState = _useState2[0],
      setActiveState = _useState2[1];

  var handleMouseDown = (0, _react.useCallback)(function (evt) {
    if (onMouseDown) onMouseDown(evt);
    setActiveState(true);
  }, [onMouseDown]);

  var handleKeyDown = (0, _react.useCallback)(function (evt) {
    if (onKeyDown) onKeyDown(evt);
    if (keyTogglesActive(evt)) setActiveState(true);
  }, [onKeyDown]);

  var handleKeyUp = (0, _react.useCallback)(function (evt) {
    if (onKeyUp) onKeyUp(evt);
    if (keyTogglesActive(evt)) setActiveState(false);
  }, [onKeyUp]);

  var handleBlur = (0, _react.useCallback)(function (evt) {
    if (onBlur) onBlur(evt);
    setActiveState(false);
  }, [onBlur]);

  // After `mousedown` on the wrapped element, `mouseup` may occur elsewhere in the document.
  (0, _react.useEffect)(function () {
    if (!activeState) return undefined;
    var handleMouseUp = function handleMouseUp() {
      setActiveState(false);
    };
    addEventListener('mouseup', handleMouseUp);
    return function () {
      removeEventListener('mouseup', handleMouseUp);
    };
  }, [activeState]);

  return {
    active: active != null ? active : activeState,
    onMouseDown: activeState ? onMouseDown : handleMouseDown,
    onKeyDown: activeState ? onKeyDown : handleKeyDown,
    onKeyUp: activeState ? handleKeyUp : onKeyUp,
    onBlur: activeState ? handleBlur : onBlur
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/hooks/useActive.js
// module id = 460
// module chunks = 177